import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { enableMapSet } from "immer";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { AuthProvider } from "./auth/authProvider";
import { store } from "./context/store";
import { ClientChangeProvider } from "./context/clientChangeProvider";
import { THEME } from "./design/muiTheme";
import FullScreenError from "./design/templates/fullscreen_error_boundary";
import "./global.css";
import { NavLayout } from "./layouts/NavLayout";
import reportWebVitals from "./reportWebVitals";

enableMapSet();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      errorElement={
        <NavLayout>
          <FullScreenError />
        </NavLayout>
      }
      path="/*"
      element={<AuthProvider />}
    />,
  ),
);

export const queryClient = new QueryClient();

root.render(
  <ThemeProvider theme={THEME}>
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <QueryClientProvider client={queryClient}>
          <ClientChangeProvider>
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
            <RouterProvider router={router} />
          </ClientChangeProvider>
        </QueryClientProvider>
      </LocalizationProvider>
    </Provider>
  </ThemeProvider>,
);

export const DEVONLY_FORCE_ONBOARDING_FLOW = false;
export const DEVONLY_FORCE_ACCOUNT_REGISTRATION = false;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
